import { render, staticRenderFns } from "./UserAnchors.vue?vue&type=template&id=1ee4bc16&"
import script from "./UserAnchors.vue?vue&type=script&lang=js&"
export * from "./UserAnchors.vue?vue&type=script&lang=js&"
import style0 from "./UserAnchors.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports